/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/**
 * A React functional component that renders the Notice Management Details page.
 * This component imports necessary dependencies from React and other libraries,
 * and also imports styles from the "noticeManagementDetails.scss" file.
 * It also imports data from the "noticeMangmentDetails.json" file.
 * The component uses hooks such as useEffect, useRef, useState, useLocation, useNavigate,
 * useTranslation, and useDispatch.
 * It also uses the Select component from the react-select library.
 * The component also imports a custom hook called useWindowDimension from "../../components/hooks/useWindowDimension".
 * It also imports the showToast function from the toast actions in the Redux store.
 * @returns The rendered Notice Management Details page.
 */
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select, { components } from "react-select";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
// import "./noticeManagementDetails.scss";
import { debounce } from "lodash";
import { saveAs } from "file-saver";
import NoticeManagementDetailsNewComponent from "./noticeManagementDetailsNewComponent";
import useWindowDimension from "../../components/hooks/useWindowDimension";
import { showToast } from "../../store/toast/actions";
import {
  changeStatusNotice,
  deleteNotice,
  getNoticeList, getNoticeReportData,
  getNoticeViewReport
} from "../../store/noticeManagement/actions";
import Constant from "../../util/constant";
import moment from "moment";
import { getDepotsList } from "../../store/depots/actions";

/**
 * Container component for managing notice management details.
 * @param {{props}} props - The props passed to the component.
 * @returns The rendered NoticeManagementDetailsComponent.
 */
const NoticeManagementDetailsNewContainer = ({ props }) => {
  /**
   * Initializes various variables and hooks for the component.
   * @returns None
   */
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pageSizeRef = useRef(10);
  const smarttableref = useRef();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const toggleDisable = useRef(false);

  const stateNoticeMagment = state?.item;

  const updateStatus = useSelector(
    (state) => state?.noticeManagement?.noticeList?.data?.data
  );
  const noticeReportData = useSelector(
    (state) => state?.noticeManagement?.noticeViewReport?.data
  );

  const pagination = useSelector(
    (state) => state?.noticeManagement?.noticeViewReport?.pagination
  );
  
  const depotList = useSelector((state) => state?.Depots?.depotsList?.data);
 
  const response = updateStatus?.filter(
    (item) => item?.noticeid === state?.item?.noticeid
  );



  const tableContainerRef = useRef(null);
  const dimensions = useWindowDimension();
  const [tabtHeight, setTabtHeight] = useState("");
  const [headerHeight, setHeaderHeight] = useState("");
  const [loaderHtml, setLoaderHtmlHeight] = useState("");
  const [tabHeaderHeight, setTabHeaderHeight] = useState("");
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [tableFilterHeight, setTableFilterHeight] = useState("");
  const [noticeTypeContentHeight, setNoticeTypeContentHeight] = useState("");

  const [showDeleteUserModal, setshowDeleteUserModal] = useState(false);
  const closeDeleteUserModal = () => setshowDeleteUserModal(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const closeStatusUserModal = () => setShowStatusModal(false);
  const [loading, setLoading] = useState(false);
  const [placeHolder, setPlaceHolder] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  const [depotMultiSelectarray, setDepotMultiSelectarray] = useState([]);
  const [noticeDetailData, setNoticeDetailData] = useState([]);

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageOptions = [5, 10, 15, 20];
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [depotIds, setDepotIds] = useState('');

  const [searchVal, setSearchVal] = useState('');
  const [sortBy, setSortBy] = useState('open');
  const [sortOrder, setSortOrder] = useState(1);
  const exportCsvHeader = [
    [
      Constant.NOTICEDETAILEXPORT.NAME,
      Constant.NOTICEDETAILEXPORT.EMAIL,
      Constant.NOTICEDETAILEXPORT.PHONE,
      Constant.NOTICEDETAILEXPORT.DEPOT,
      Constant.NOTICEDETAILEXPORT.OPEN,
      Constant.NOTICEDETAILEXPORT.DOWNLOADED,
      Constant.NOTICEDETAILEXPORT.SIGNED,
    ],
  ];
  const [exportCsvData, setexportCsvData] = useState([]);

  /**
   * Opens the delete user modal for the specified item.
   * @param {{Event}} e - The event object.
   * @param {{any}} item - The item to be deleted.
   * @returns None
   */
  const openDeleteUserModal = (e, item) => {
    setshowDeleteUserModal(true);
  };

  /**
   * Retrieves the notice list by dispatching the 'getNoticeList' action.
   * Sets the placeholder to false and logs the response.
   * @returns None
   */
  const getList = () => {
    dispatch(
      getNoticeList(
        {search: state?.item?.title},
        (res) => { },
        (err) => { }
      )
    );

    let queryParams = { page : currentPage, limit : itemsPerPage, sortBy: sortBy, sortOrder: sortOrder };

    // const searchValue = localStorage.getItem("searchValueDetail");
    if(searchValue){
      queryParams.search = searchValue
    }

    // console.log("searchValue",searchValue);

    setPlaceHolder(true);

    dispatch(
      getDepotsList(
        {},
        (res) => {
          const allDepotIds = state?.item?.depotname?.map(i => i.depotid)
          const depotIds = res?.data?.filter(i => allDepotIds.includes(i.depotid))?.map((item) => item.depotid)?.join(',');
          setDepotIds(depotIds)
          const depotFilter = localStorage.getItem("depotFilterDetail");
          const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
          if(depotFilterObject){
            queryParams.depotid = depotFilterObject?.map(i => i.id)
          } else {
            queryParams.depotid = depotIds
          }
          dispatch(
            getNoticeViewReport(state?.item?.noticeid, queryParams,  (res) => {
              if (res && state?.item?.title !== "") {
                setPlaceHolder(false);
              }
            })
          );
         },
        (err) => { }
      )
    );

  };

  useEffect(() => {
    setTotalPages(pagination?.totalPages)
  }, [pagination])

  /**
   * Loads more items when triggered, with a delay of 2000 milliseconds.
   * @returns None
   */
  const loadMoreItems = () => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      pageSizeRef.current += 2;
    }, 2000);
  };

  /**
   * Debounces the handleTableScroll function to prevent it from being called too frequently.
   * When the table container is scrolled, it checks if the scroll position is at the bottom
   * and if there are more items to load. If both conditions are met, it calls the loadMoreItems function.
   * @returns None
   */
  const handleTableScroll = debounce(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      const isAtBottom =
        tableContainer.scrollTop + tableContainer.clientHeight >=
        tableContainer.scrollHeight;
      if (isAtBottom && noticeReportData?.length > pageSizeRef.current) {
        loadMoreItems();
      }
    }
  }, 200);

  useEffect(() => {
    getList();
  }, []);

  /**
   * Adds an event listener to the table container element to handle scroll events.
   * The event listener is removed when the component is unmounted.
   * @param {{function}} handleTableScroll - The function to handle the table scroll event.
   * @returns None
   */
  useEffect(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      tableContainer.addEventListener("scroll", handleTableScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleTableScroll);
      }
    };
  }, [handleTableScroll]);

  /**
   * Updates the heights of various elements on the page when the loading state changes.
   * @param {{boolean}} loading - The loading state of the page.
   * @returns None
   */
  useEffect(() => {
    loading &&
      setLoaderHtmlHeight(
        document.getElementsByClassName("infinate-load")[0]?.offsetHeight
      );
    setHeaderHeight(
      document.getElementsByClassName("navbar-header")[0]?.offsetHeight
    );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0]?.offsetHeight
    );
    setNoticeTypeContentHeight(
      document.getElementsByClassName("noticeContaint")[0]?.offsetHeight
    );
    setTabtHeight(
      document.getElementsByClassName("TabCustome")[0]?.offsetHeight
    );

    setTableFilterHeight(
      document.getElementsByClassName("FormButton_Wrapper")[0]?.offsetHeight
    );
    setTabHeaderHeight(document.getElementsByTagName("thead")[0]?.offsetHeight);
  }, [loading]);

  /**
   * Navigates to the "/noticemanagement" page.
   * @returns None
   */
  const backPageFunction = () => {
    navigate("/noticemanagement");
  };

  /**
   * An array of column objects used for displaying a table.
   * Each column object contains a label, key, filter function, and sorting flag.
   * @type {Array}
   */
  const columns = [
    {
      label: <>{t("USER_DETAILS")}</>,
      key: "fullname",
      filter: false,
      sorter: false,
    },
    {
      label: <>{t("USER_DETAILS")}</>,
      key: "emailid",
      filter: false,
      sorter: false,
    },
    {
      label: <>{t("USER_DETAILS")}</>,
      key: "phone",
      filter: false,
      sorter: false,
    },
    {
      label: <>{t("DEPOT")}</>,
      key: "depotname",
      filter: (values, onChange) => {
        const unique = [...new Set(values)].sort();
        const _depotOptions = unique?.map((elementdepot) =>
          elementdepot?.map((item) => ({
            label: item?.depotname,
            value: item?.depotname,
          }))
        );
        let finalarr = [];
        const depotOptions = _depotOptions?.flatMap((item) => item);
        depotOptions?.forEach((item) => {
          let options = finalarr?.map((i) => i.label);
          if (!options.includes(item?.label)) {
            finalarr.push(item);
          }
        });

        const handleChange = (selected) => {
          setDepotMultiSelectarray(selected);
          const selectedValues = selected.map(
            (elementdepot) => elementdepot.value
          );
          onChange((item) => {
            // eslint-disable-next-line array-callback-return
            const _filterValue = item?.filter((innerItem) => {
              if (selectedValues?.includes(innerItem?.depotname)) {
                return innerItem;
              }
            });
            return Array.isArray(selectedValues) && selectedValues?.length
              ? selectedValues.includes(_filterValue[0]?.depotname)
              : true;
          });
        };
        const CustomOption = ({ children, ...props }) => {
          return (
            <components.Option {...props}>
              <input type="checkbox" checked={props.isSelected} />
              <label for="checkbox">
                <span></span>
              </label>
              {children}
            </components.Option>
          );
        };

        return (
          <div
            className={
              depotMultiSelectarray?.length > 1
                ? "multipleselectWrapper customeSelectWrapper"
                : "customeSelectWrapper"
            }
          >
            <Select
              isMulti
              onChange={handleChange}
              options={finalarr}
              closeMenuOnSelect={false}
              placeholder={t("SELECT")}
              hideSelectedOptions={false}
              components={{ Option: CustomOption }}
              className="react-select-container multiSelecter"
              classNamePrefix="react-select"
            />
            {depotMultiSelectarray?.length > 1 && (
              <p className="multiselectTag">
                +{depotMultiSelectarray?.slice(1)?.length}
              </p>
            )}
          </div>
        );
      },
      sorter: false,
    },
    {
      label: <>{t("OPEN")}</>,
      key: "open",
      filter: false,
    },
    {
      label: <>{t("DOWNLOADED")}</>,
      key: "downloaded",
      filter: false,
    },
    state?.item?.signrequired ? {
      label: <>{t("SIGNED")}</>,
      key: "signed",
      filter: false,
    } :
      {
        key: "signed1",
        label: false,
        filter: false,
        sorting: false,
      }
    ,
  ];

  /**
   * Opens the export modal and displays a success toast message.
   * Navigates to the "/noticemanagement" page after a delay of 1500 milliseconds.
   * @returns None
   */
  const openExportModal = () => {
    setTimeout(() => {
      dispatch(
        showToast({
          message: t("NOTICE_HAS_BEEN_EXPORTED_SUCCESSFULLY"),
          type: "success",
        })
      );
      navigate("/noticemanagement");
    }, 1500);
  };

  /**
   * Executes a series of actions when a user is deleted.
   * - Displays a success toast message.
   * - Closes the delete user modal.
   * @returns None
   */
  const onDeleteUser = () => {
    dispatch(
      deleteNotice(
        state?.item?.noticeid,
        (res) => {
          if (res?.response?.status !== 409) {
            navigate("/noticemanagement");
          }
          closeDeleteUserModal();
        },
        (err) => console.log(err)
      )
    );
  };

  /**
   * Displays a toast notification indicating that a download was successful.
   * @returns None
   */
  const downloadNoticeValue = (item) => {
    const s3ObjectKey = item;
    const s3BucketUrl = process.env.REACT_APP_AWS_UPLOAD_DOCUMENT_URL;
    const documentUrl = `${s3BucketUrl}${encodeURIComponent(s3ObjectKey)}`;
    saveAs(documentUrl, s3ObjectKey);
    dispatch(
      showToast({
        message: t("DOWNLOADED_SUCCESSFULLY"),
        type: "success",
      })
    );
  };

  /**
   * Handles the action when a check event occurs.
   * @param {{Event}} e - The event object.
   * @param {{Array}} noticeMangmentData - The array of notice management data.
   * @returns None
   */
  const onCheckAction = () => {
    if (response[0]?.noticestatus === Constant.GENERALKEYS.ACTIVE) {
      setShowStatusModal(true);
    } else {
      onActive();
    }
  };

  /**
   * Function to handle the proceed action after a certain event.
   * It sets the value of isCheckSwitch to false and showStatusModal to false.
   * It then dispatches a showToast action with a success message.
   * Finally, it closes the deleteUserModal after a delay of 1000 milliseconds.
   * @returns None
   */
  const onProcced = () => {
    setBtnLoader(true);
    const params = {
      noticestatus: Constant.GENERALKEYS.INACTIVE,
    };

    dispatch(
      changeStatusNotice(
        state?.item?.noticeid,
        params,
        (res) => {
          getList();
          setBtnLoader(false);
          setShowStatusModal(false);
        },
        (err) => {
          setBtnLoader(false);
          setShowStatusModal(false);
          console.log(err);
        }
      )
    );
  };

  /**
   * Handles an unable action event.
   * @param {{Event}} e - The event object.
   * @param {{string}} id - The ID of the action.
   * @returns None
   */
  const onActive = () => {
    const params = {
      noticestatus: Constant.GENERALKEYS.ACTIVE,
    };
    if (!toggleDisable.current) {
      toggleDisable.current = true;
      dispatch(
        changeStatusNotice(
          state?.item?.noticeid,
          params,
          (res) => {
            getList();
            toggleDisable.current = false;
          },
          (err) => {
            toggleDisable.current = false;
            console.log(err);
          }
        )
      );
    }
  };

  /**
   * Handles sorting when a column header is clicked.
   * @param {string} columnKey - The key of the column being sorted
   * @returns None
   */
  const handleColumnSort = (columnKey) => {
    let newSortOrder;
    let newSortBy = columnKey;

    // If clicking the same column, toggle order; otherwise set to ascending
    if (sortBy === columnKey) {
      newSortOrder = sortOrder === 1 ? -1 : 1;
    } else {
      newSortOrder = 1;
    }

    setSortBy(newSortBy);
    setSortOrder(newSortOrder);
    setCurrentPage(1);

    // Build query params with new sort values
    let queryParams = {
      page: 1,
      limit: itemsPerPage,
      sortBy: newSortBy,
      sortOrder: newSortOrder,
    };

    if (searchValue) {
      queryParams.search = searchValue;
    }

    const depotFilter = localStorage.getItem("depotFilterDetail");
    const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
    if (depotFilterObject) {
      queryParams.depotid = depotFilterObject?.map((i) => i.id);
    } else {
      queryParams.depotid = depotIds;
    }

    setPlaceHolder(true);
    dispatch(
      getNoticeViewReport(state?.item?.noticeid, queryParams, (res) => {
        if (res && state?.item?.title !== "") {
          setPlaceHolder(false);
        }
      })
    );
  };

  /**
   * Clears the search input field by programmatically clicking the first button element
   * within the smart table component.
   * @returns None
   */
  const clearSearchButton = () => {
    smarttableref.current.querySelectorAll("button")[0].click();
  };

  const onTableFilterChange = (filterText) => {
    setSearchValue(filterText);
  };
  const searchFilterClear = () => {
    smarttableref.current.querySelectorAll("button")[1].click();
  };

  const editNoticeFun = (item) => {
    navigate("/noticemanagement/editnotice", {
      state: {
        state,
      },
    });
  };

  const [isExportingData, setIsExportingData] = useState(false);

  const exportDataToCSV = (data) => {
    const csvContent = [
      ["Name", "Email", "Phone", "Depot", "Opened", "Downloaded", "Signed"], // Fixed headers
      ...data.map(item => [
        item.fullname || '-',
        item.emailid || '-',
        item.phone || '-',
        `"${(item.depot || '-').replace(/"/g, '""')}"`, // wrap in quotes
        item.open ? moment(item.open).format("DD-MM-YYYY h:mm A") : '-',
        item.downloaded ? moment(item.downloaded).format("DD-MM-YYYY h:mm A") : '-',
        item.signed ? moment(item.signed).format("DD-MM-YYYY h:mm A") : '-',
      ])
    ];

    const csvString = csvContent.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvString], { type: 'text/csv' });
    saveAs(blob, `notice-report-${moment().format('YYYY-MM-DD')}.csv`);
  };



  const fetchAllDataForExport = async () => {
    setIsExportingData(true);

    try {
      let allData = [];
      let currentPage = 1;
      const pageSize = 50;

      while (true) {
        const params = {
          page: currentPage,
          limit: pageSize,
          sortBy,
          sortOrder,
        };

        if (searchValue) params.search = searchValue;

        const depotFilter = localStorage.getItem("depotFilterDetail");
        const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
        params.depotid = depotFilterObject?.length > 0
            ? depotFilterObject.map(d => d.id)
            : depotIds;

        console.debug('Fetching export data, page:', currentPage, 'params:', params);

        const response = await new Promise((resolve, reject) => {
          dispatch(
              getNoticeReportData(
                  state?.item?.noticeid,
                  params,
                  (res) => resolve(res),
                  (err) => reject(err)
              )
          );
        });

        const responseData = response?.data || [];
        if (responseData.length === 0) break;

        // Transform each row
        const cleaned = responseData.map(item => ({
          fullname: item.fullname || "",
          emailid: item.emailid || "",
          phone: item.phone || "",
          // Convert depot array into a single string
          depot: Array.isArray(item.depotname) && item.depotname.length > 0
              ? item.depotname.map(d => d.depotname || "").join(", ")
              : "",
          open: item.open || null,
          downloaded: item.downloaded || null,
          signed: item.signed || null,
        }));

        allData.push(...cleaned);

        if (responseData.length < pageSize) break;
        currentPage++;
      }

      if (allData.length > 0) {
        exportDataToCSV(allData);
        dispatch(showToast({
          message: t("NOTICE_HAS_BEEN_EXPORTED_SUCCESSFULLY"),
          type: "success",
        }));
      } else {
        dispatch(showToast({
          message: t("NO_DATA_TO_EXPORT"),
          type: "warning",
        }));
      }

    } catch (error) {
      console.error("Error fetching export data:", error);
      dispatch(showToast({
        message: t("ERROR_EXPORTING_DATA"),
        type: "error",
      }));
    } finally {
      setIsExportingData(false);
    }
  };





  useEffect(() => {
    if (noticeReportData !== undefined && noticeReportData?.length > 0) {
      // This now only handles the current page data for table display
      // Export data is handled separately in fetchAllDataForExport
    }
  }, [noticeReportData]);

  /**
   * Renders the NoticeManagementDetailsComponent with the provided props.
   * @param {{function}} backPageFunction - The function to navigate back to the previous page.
   * @param {{array}} columns - The columns configuration for the table.
   * @param {{array}} noticeMangmentData - The data to be displayed in the table.
   * @param {{object}} dimensions - The dimensions of the table.
   * @param {{boolean}} loading - Indicates whether the data is still loading.
   * @param {{string}} loaderHtml - The HTML to be displayed while the data is loading.
   * @param {{number}} headerHeight - The height of the table header.
   * @param {{object}} smarttableref - The reference to the Smart
   */

  const onFilteredItemsChange = (data) => {
    setNoticeDetailData(data);
    if (data !== undefined && data.length > 0) {
      const firstcolumns = [
        { key: "fullname" },
        { key: "emailid" },
        { key: "phone" },
      ];
      setexportCsvData(
        noticeReportData.map((i) => {
          // return firstcolumns.concat(columns.slice(1)).map((item) => {
          return columns.map((item) => {
            if (i[item.key] === undefined) {
              return "";
            } else if (
              item.key == "open" ||
              item.key == "downloaded" ||
              item.key == "signed"
            ) {
              if (
                moment(i[item.key]).format("DD-MM-YYYY h:mm A ") ==
                "Invalid date"
              ) {
                return "-";
              } else {
                return moment(i[item.key]).format("DD-MM-YYYY h:mm A ");
              }
            } else if (Array.isArray(i[item.key])) {
              return i[item.key].map((x) => x.depotname).join(", ");
            } else if (i[item.key] === "" || i[item.key] == null) {
              return "-";
            } else {
              return i[item.key];
            }
          });
        })
      );
      // setexportCsvData(
      //   noticeReportData.map((i) => {
      //     return firstcolumns.concat(columns.slice(1)).map((item) => {
      //       if (i[item.key] === undefined) {
      //         return "";
      //       } else if (moment(i[item.key]).isValid()) {
      //         return moment(i[item.key]).format("DD-MM-YYYY h:mm A ");
      //       } else if (Array.isArray(i[item.key])) {
      //         return i[item.key].map((x) => x.depotname).join(", ");
      //       } else if (i[item.key] === "" || i[item.key] == null) {
      //         return "-";
      //       } else {
      //         return i[item.key];
      //       }
      //     });
      //   })
      // );
    }
  };

  const depotTypeFilter = (values, onChange) => {
    const allDepotIds = state?.item?.depotname?.map(i => i.depotid)
    const options = depotList?.filter(i => allDepotIds.includes(i.depotid))?.map((item) => {
      return { id: item.depotid, label: item?.name, value: item?.name }
    });;

    const handleChange = (selected) => {
    setCurrentPage(1);

    let queryParams = { page: 1, limit: itemsPerPage, sortBy: sortBy, sortOrder: sortOrder };

    // const searchValueLocal = localStorage.getItem("searchValue");
    // if(searchValueLocal){
    //   queryParams.search = searchValueLocal
    // }

    if(searchValue){
      queryParams.search = searchValue
    }
    
      if (selected?.length > 0) {
      localStorage.setItem("depotFilterDetail", JSON.stringify(selected));
      const selcetedDepotTypeIdList = selected.map(i => i.id)
      queryParams.depotid = selcetedDepotTypeIdList
    } else {
        queryParams.depotid = depotIds
        localStorage.removeItem("depotFilterDetail");
      }
      setPlaceHolder(true);
    
      dispatch(
        getNoticeViewReport(state?.item?.noticeid, queryParams,  (res) => {
          if (res && state?.item?.title !== "") {
            setPlaceHolder(false);
          }
        })
      );
  
        setDepotMultiSelectarray(selected);
      
        const selectedValues = selected?.map((item) => item?.value);
      
        onChange((items) => {
          if (!Array.isArray(items)) return items;
      
          if (!selectedValues.length) return items; // If no filter is applied, return all items
      
          return items.filter((innerItem) =>
            selectedValues.includes(innerItem?.noticetypename)
          );
        });
      };
      
      const CustomOption = ({ children, ...props }) => {
        return (
          <components.Option {...props}>
            <input type="checkbox" checked={props.isSelected} />
            <label htmlFor="checkbox">
              <span></span>
            </label>
            {children}
          </components.Option>
        );
      };
  
      return (
        <div
          className={
            depotMultiSelectarray?.length > 1
              ? "multipleselectWrapper customeSelectWrapper"
              : "customeSelectWrapper"
          }
        >
          <Select
            closeMenuOnSelect={false}
            isMulti
            onChange={handleChange}
            options={options}
            hideSelectedOptions={false}
            components={{ Option: CustomOption }}
            placeholder={t("SELECT")}
            className="react-select-container multiSelecter"
            classNamePrefix="react-select"
            defaultValue={
              localStorage.getItem("depotFilterDetail")
                ? JSON.parse(localStorage.getItem("depotFilterDetail"))
                : undefined
            }
          />
          {depotMultiSelectarray?.length > 1 && (
            <p className="multiselectTag">
              +{depotMultiSelectarray?.slice(1)?.length}
            </p>
          )}
        </div>
      );
    };
    const handleItemsPerPageChange = (event) => {
      setItemsPerPage(Number(event.target.value));

    let queryParams = { page : 1, limit : Number(event.target.value), sortBy: sortBy, sortOrder: sortOrder };

    // const searchValue = localStorage.getItem("searchValue");
    if(searchValue){
      queryParams.search = searchValue
    }

    const depotFilter = localStorage.getItem("depotFilterDetail");
    const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
    if(depotFilterObject){
      queryParams.depotid = depotFilterObject?.map(i => i.id)
    } else {
      queryParams.depotid = depotIds
    }
    setPlaceHolder(true);

    dispatch(
      getNoticeViewReport(state?.item?.noticeid, queryParams,  (res) => {
        if (res && state?.item?.title !== "") {
          setPlaceHolder(false);
        }
      })
    );

      setCurrentPage(1);
    };

    const handlePageClick = (page) => {
      setCurrentPage(page);

      let queryParams = { page : page, limit : itemsPerPage, sortBy: sortBy, sortOrder: sortOrder };

    // const searchValue = localStorage.getItem("searchValue");
    if(searchValue){
      queryParams.search = searchValue
    }

    const depotFilter = localStorage.getItem("depotFilterDetail");
    const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
    if(depotFilterObject){
      queryParams.depotid = depotFilterObject?.map(i => i.id)
    } else {
      queryParams.depotid = depotIds
    }
    setPlaceHolder(true);

    dispatch(
      getNoticeViewReport(state?.item?.noticeid, queryParams,  (res) => {
        if (res && state?.item?.title !== "") {
          setPlaceHolder(false);
        }
      })
    );

    };

    const searchClearButton = () => {
      setSearchValue(null);
      setCurrentPage(1);
      let queryParams = { page: 1, limit: itemsPerPage, sortBy: sortBy, sortOrder: sortOrder };

      const depotFilter = localStorage.getItem("depotFilterDetail");
      const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
      if(depotFilterObject){
        queryParams.depotid = depotFilterObject?.map(i => i.id)
      } else {
        queryParams.depotid = depotIds
      }
      setPlaceHolder(true);
      
      dispatch(
        getNoticeViewReport(state?.item?.noticeid, queryParams,  (res) => {
          if (res && state?.item?.title !== "") {
            setPlaceHolder(false);
          }
        })
      );

    };
  const abortControllerRef = useRef(null); // Properly initialized

  useEffect(() => {
    if (!searchValue) return;

    // Cancel previous API call before making a new one
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller; // Correctly assigning controller

    let queryParams = { page: currentPage, limit: itemsPerPage, search: searchValue, sortBy: sortBy, sortOrder: sortOrder };

    const depotFilter = localStorage.getItem("depotFilterDetail");
    if (depotFilter) {
      queryParams.depotid = JSON.parse(depotFilter)?.map((i) => i.id);
    } else {
      queryParams.depotid = depotIds
    }

    const fetchResults = debounce(() => {
      setPlaceHolder(true);

      dispatch(
        getNoticeViewReport(state?.item?.noticeid, queryParams, (res) => {
          if (res && state?.item?.title !== "") {
            setPlaceHolder(false);
          }
        }, { signal: controller.signal }) // Correctly passing the abort signal
      );
    }, 500);

    fetchResults();

    return () => {
      fetchResults.cancel(); // Cancel debounce on cleanup
    };
  }, [searchValue]);

    const onSearchValue = (value) => {
      setSearchValue(value);
      setCurrentPage(1);
      // if (value) {
      //   localStorage.setItem("searchValueDetail", value)
      // } else {
      //   localStorage.removeItem("searchValueDetail")
      // }
    };
  return (
    <NoticeManagementDetailsNewComponent
      backPageFunction={backPageFunction}
      columns={columns}
      noticeMangmentData={noticeReportData}
      dimensions={dimensions}
      loading={loading}
      loaderHtml={loaderHtml}
      headerHeight={headerHeight}
      smarttableref={smarttableref}
      tabHeaderHeight={tabHeaderHeight}
      itemsPerPage={itemsPerPage}
      breadcrumbHeight={breadcrumbHeight}
      tableFilterHeight={tableFilterHeight}
      noticeTypeContentHeight={noticeTypeContentHeight}
      tabtHeight={tabtHeight}
      tableContainerRef={tableContainerRef}
      handleColumnSort={handleColumnSort}
      sortBy={sortBy}
      sortOrder={sortOrder}
      noDataFound={"No Report Found"}
      noDataTitle={t("NO_REPORT_FOUND")}
      noDataDesc={t(
        "YOUR_SEARCH_DID_NOT_MATCH_ANY_REPORTS_PLEASE_TRY_SEARCHING_AGAIN"
      )}
      openExportModal={openExportModal}
      showDeleteUserModal={showDeleteUserModal}
      openDeleteUserModal={(e, item) => {
        openDeleteUserModal(e, item);
      }}
      closeDeleteUserModal={closeDeleteUserModal}
      closeDeactiveModal={closeStatusUserModal}
      onDeleteUser={onDeleteUser}
      state={state}
      downloadNoticeValue={(item) => {
        downloadNoticeValue(item);
      }}
      onCheckAction={(e, noticeMangmentData) =>
        onCheckAction(e, noticeMangmentData)
      }
      showStatusModal={showStatusModal}
      isCheckSwitch={
        response === undefined
          ? ""
          : response[0]?.noticestatus === Constant.GENERALKEYS.ACTIVE
            ? true
            : false
      }
      onProcced={onProcced}
      clearSearchButton={clearSearchButton}
      editNoticeFun={() => {
        editNoticeFun();
      }}
      loaderButtonShow={btnLoader}
      onTableFilterChange={onTableFilterChange}
      searchValue={searchValue}
      searchFilterClear={searchFilterClear}
      placeHolderShimer={placeHolder}
      exportCsvData={exportCsvData}
      onFilteredItemsChange={onFilteredItemsChange}
      exportCsvHeader={exportCsvHeader}
      noticeDetailData={noticeDetailData}

      depotTypeFilter={depotTypeFilter}
      handlePageClick={handlePageClick}
      handleItemsPerPageChange={handleItemsPerPageChange}
      itemsPerPageOptions={itemsPerPageOptions}
      searchVal={searchVal}
      searchClearButton={searchClearButton}
      onSearchValue={onSearchValue}
      totalPages={totalPages}
      currentPage={currentPage}
      pagination={pagination}
      depotList={depotList}
      handleExportClick={fetchAllDataForExport}
      isExportingData={isExportingData}
      stateNoticeMagment={stateNoticeMagment}
    />
  );
};
export default NoticeManagementDetailsNewContainer;
